import { render, staticRenderFns } from "./InputData.vue?vue&type=template&id=20486ea8&"
import script from "./InputData.vue?vue&type=script&lang=js&"
export * from "./InputData.vue?vue&type=script&lang=js&"
import style0 from "./InputData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports